// src/layouts/MainLayout.jsx

import React, { useState } from "react";
import logo from "../assets/iconos/logofinal_gov.png";
import logoBlanco from "../assets/fondos/LogoBlancoPiedecuestana.png";
import {FaTwitter,FaFacebook,FaInstagram,FaYoutube} from 'react-icons/fa';

// Clave secreta que se debe escribir para confirmar la indexación
const INDEXING_KEY = "facturas:indexar"; 

export default function MainLayout({ children }) {
  // 1. Estado para controlar la visibilidad del modal y la clave
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [keyInput, setKeyInput] = useState('');

  // 2. Función para manejar el disparo de la indexación
  const handleIndexing = () => {
    // Aquí se hace la llamada a tu API o endpoint
    // que ejecuta el comando 'php artisan facturas:indexar'
        fetch('/api/indexar-facturas', { method: 'POST' })
      .then(response => {
        if (response.ok) {
          alert('Indexación iniciada con éxito en el servidor.');
        } else {
          alert('Fallo al iniciar la indexación.');
        }
      })
      .catch(error => console.error('Error de red:', error));

    
    
    console.log("¡Indexación Iniciada!");
    console.log(">>> Comando ejecutado en el servidor: php artisan facturas:indexar");


    // Cerrar el modal y limpiar la clave
    setIsModalOpen(false);
    setKeyInput('');
  };

  // 3. Manejador del Control + Clic en la esquina
  const handleControlClick = (event) => {
    // Previene el menú contextual del navegador
    event.preventDefault(); 
    
    // Verifica si la tecla Control (o Command en Mac) está presionada
    if (event.ctrlKey || event.metaKey) {
      setIsModalOpen(true);
    }
  };

  // 4. Manejador de la confirmación del modal
  const handleConfirm = () => {
    if (keyInput === INDEXING_KEY) {
      handleIndexing();
    } else {
      alert("Clave incorrecta. Intente de nuevo.");
      setKeyInput('');
    }
  };

  return (
    <div className="flex flex-col min-h-screen">

      {/* Header */}
      <header className="bg-secondary text-white flex justify-between items-center px-6 py-3 shadow-md z-30 relative">
        <div className="flex items-center gap-3">
          <a href="https://www.gov.co" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" className="h-8 w-auto"/>
          </a>
          <h1 className="font-semibold">
            Descarga tu Factura Piedecuestana E.S.P.
          </h1>
        </div>

        {/* 2. ELEMENTO INVISIBLE EN LA ESQUINA SUPERIOR DERECHA */}
        <div 
          className="absolute top-0 right-0 w-10 h-10 z-50"
          title="¿indexar?" // Tooltip para saber dónde hacer clic
          onContextMenu={handleControlClick}
        />
        {/* FIN ELEMENTO INVISIBLE */}

      </header>

      {/* 3. MODAL DE CONFIRMACIÓN */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
            <h3 className="text-xl font-bold mb-4 text-gray-800">
              ¿Desea iniciar la indexación?
            </h3>
            <p className="mb-4 text-sm text-gray-600">
              Para confirmar y ejecutar el comando `facturas:indexar`, escriba la clave a continuación:
            </p>
            
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Escriba aquí la clave secreta"
              value={keyInput}
              onChange={(e) => setKeyInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
            />

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                onClick={() => {
                  setIsModalOpen(false);
                  setKeyInput('');
                }}
              >
                Cancelar
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
                onClick={handleConfirm}
                disabled={keyInput !== INDEXING_KEY}
              >
                Aceptar y Ejecutar
              </button>
            </div>
          </div>
        </div>
      )}
      {/* FIN MODAL */}

      {/* Contenido */}
      <main className="flex-1 bg-gray-50 p-6">
        {children}
      </main>

      {/* Footer (sin cambios) */}
      <footer className="bg-neutral-900 text-gray-300 pt-12 pb-6 text-sm">
        {/* ... (Todo el contenido del footer permanece igual) ... */}
        {/* Contenido omitido por brevedad */}
        
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-start gap-12">
            <div className="flex-shrink-0">
              <img
                src={logoBlanco}
                alt="Logo Piedecuestana"
                className="w-60 h-auto opacity-95"
              />
              <div className="container mx-auto px-1 mt-2">
                <div className="grid md:grid-cols-4 gap-6">
                  <a href="https://x.com/Piedecuestana_">
                    <FaTwitter size={24} className="text-white hover:text-gray-400"/>
                  </a>
                  <a href="https://www.facebook.com/PiedecuestanaESP/">
                    <FaFacebook size={24} className="text-white hover:text-gray-400"/>
                  </a>
                  <a href="https://www.instagram.com/explore/locations/517399849/piedecuestana-de-servicios-publicos-esp/">
                    <FaInstagram size={24} className="text-white hover:text-gray-400"/>
                  </a>
                  <a href="https://www.youtube.com/channel/UCxo9lqL0DHWyLH9VcwzxQbw">
                    <FaYoutube size={24} className="text-white hover:text-gray-400"/>
                  </a>
                </div>
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-12 flex-1 text-center">
              <div>
                <h3 className="text-lg font-semibold mb-4 text-white">Líneas de atención</h3>
                <p className="text-white font-semibold">Reporte de emergencias</p>
                <p>WhatsApp: 316 744 4528</p>
                <p className="text-white mt-4 font-semibold">Email</p>
                <p>servicioalcliente@piedecuestanaesp.gov.co</p>
                <p>buzon@piedecuestanaesp.gov.co</p>
                <p className="text-white mt-4 font-semibold">Línea anticorrupción</p>
                <p>Móvil: 3167444528</p>
                <p className="text-white mt-4 font-semibold">Sede Administrativa</p>
                <p>Carrera 8 # 12-28, Barrio La Candelaria</p>
                <p>Piedecuesta, Santander, Colombia</p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4 text-white">Horarios de atención</h3>
                <p className="text-white font-semibold">Lunes a viernes</p>
                <p>7:30 am - 4:30 pm (Jornada continua)</p>
                <p className="text-white mt-4 font-semibold">Ventanilla única</p>
                <p>7:30 am - 11:30 am</p>
                <p>1:30 pm – 4:30 pm</p>
                <p>recepcion@piedecuestanaesp.gov.co</p>
                <p>Notificaciones judiciales</p>
                <p>oficinajuridica@piedecuestanaesp.gov.co</p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4 text-white">Plantas de Tratamiento</h3>
                <p className="text-white font-semibold">PTAP La Colina</p>
                <p>Carrera 19 # 6, Cabecera del Llano</p>
                <p className="text-white font-semibold mt-3">PTAR El Santuario</p>
                <p>Vereda Guatiguará</p>
                <p className="text-white font-semibold mt-3">PTAR La Diva</p>
                <p>Vereda Guatiguará – Sector La Diva</p>
              </div>
            </div>
          </div>
          <div className="container mx-auto px-4 mt-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-center">
              <div></div>
              <div>
                <a 
                  href="https://piedecuestanaesp.gov.co/terminos-y-condiciones-sitio-web/"
                  className="text-white font-semibold underline hover:text-gray-400 block"
                >
                  Términos y condiciones
                </a>
              </div>
              <div>
                <a 
                  href="https://piedecuestanaesp.gov.co/wp-content/uploads/2020/01/ACUERDO-NO.-011-DE-2018_POLI-TRATAMIENTO-DE-DATOS.pdf"
                  className="text-white font-semibold underline hover:text-gray-400 block"
                >
                  Política, privacidad y tratamiento de datos personales
                </a>
                <a 
                  href="https://piedecuestanaesp.gov.co/politica-de-derechos-de-autor/"
                  className="text-white font-semibold underline hover:text-gray-400 block mt-2"
                >
                  Política de Derechos de Autor
                </a>
                <p className="text-gray-400 mt-4">Piedecuestana de Servicios Públicos E.S.P</p>
                <p className="text-gray-400">© {new Date().getFullYear()} Todos los derechos reservados</p>
                <p className="text-gray-400">By Duver Jaimes tel:3172115716</p>
              </div>
              <div>
                <a 
                  href="https://piedecuestanaesp.gov.co/mapa-del-sitio/"
                  className="text-white font-semibold underline hover:text-gray-400 block"
                >
                  Mapa del sitio
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-400 text-center"></div>
          <p className="text-center">empresa municipal de servicios públicos domiciliarios de Piedecuesta e.s.p. - Piedecuestana de Servicios Públicos - Piedecuesta, Santander Dream-Theme — truly premium WordPress themes</p>
        </div>
      </footer>
    </div>
  );
}